module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/instagram/sola_sns_04-71a740d286b66d3f6208376cb6f65cc3.jpg";